"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Dollar = function Dollar(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.5,0H14c-0.773-0.002-1.515,0.306-2.061,0.854L0.5,12.293c-0.667,0.667-0.667,1.747,0,2.414L9.293,23.5 c0.667,0.667,1.747,0.667,2.414,0l11.439-11.439C23.695,11.516,24.002,10.774,24,10V1.5C24,0.672,23.328,0,22.5,0z M14.187,10.714 c0.561,2.089,1.09,4.062-0.044,5.2c-1.099,1.123-2.899,1.142-4.022,0.043c-0.015-0.014-0.029-0.029-0.043-0.043L10.065,15.9 c-0.098-0.097-0.256-0.097-0.354,0l-0.782,0.783c-0.384,0.397-1.017,0.408-1.414,0.025c-0.397-0.384-0.408-1.017-0.025-1.414 c0.008-0.008,0.016-0.017,0.025-0.025l0.782-0.783c0.098-0.098,0.098-0.256,0-0.354c0,0,0,0,0,0l-1.338-1.34 c-0.391-0.39-0.391-1.024-0.001-1.415c0.39-0.391,1.024-0.391,1.415,0l0,0l2.215,2.215l0,0l0.007,0.006l0,0l0.008,0.008 l0.886,0.886c0.32,0.342,0.857,0.359,1.199,0.038c0.013-0.012,0.026-0.025,0.038-0.038c0.318-0.318-0.237-2.383-0.473-3.264 c-0.561-2.089-1.09-4.062,0.045-5.2c1-1.122,2.721-1.221,3.843-0.221c0.078,0.069,0.152,0.143,0.221,0.221l0,0l0.013,0.013 c0.098,0.097,0.256,0.097,0.354,0l0.783-0.782c0.384-0.397,1.017-0.408,1.414-0.025c0.397,0.384,0.408,1.017,0.025,1.414 c-0.008,0.008-0.016,0.017-0.025,0.025l-0.783,0.782c-0.097,0.098-0.097,0.255,0,0.353l1.338,1.339 c0.384,0.397,0.373,1.03-0.025,1.414c-0.388,0.374-1.002,0.374-1.389,0l-2.204-2.199l-0.01-0.009V8.347l-0.009-0.009l0,0 l-0.885-0.885c-0.241-0.341-0.714-0.422-1.055-0.181c-0.07,0.05-0.131,0.111-0.181,0.181C13.4,7.768,13.951,9.833,14.187,10.714z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Dollar.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Dollar.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Dollar;